import portfolioData from "../data/portfolioData";
import { Gallery4 } from "./ui/Gallery4";

function Portfolio() {
  if (portfolioData.length === 0) return null;

  return (
    <div id="trabajos" className="bg-soft-gray">
      <Gallery4
        title="Trabajos"
        description="Proyectos seleccionados donde estrategia y diseño se encuentran para crear experiencias memorables."
        items={portfolioData}
      />
    </div>
  );
}

export default Portfolio;
